/// <amd-module name="TFS/Security/Common/Permissions/DataSource/SecurityPermissionsDataSource" />
import { PermissionTrace, SubjectPermissions } from "TFS/Admin/Common/Contracts/OrganizationSettings";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const PermissionsMetadataProviderId = "ms.vss-admin-web.security-view-permissions-data-provider";
const PermissionsTraceMetadataProviderId = "ms.vss-admin-web.security-view-permissions-trace-data-provider";

export function getResourcesSecurityPermissions(
    pageContext: IVssPageContext,
    subjectDescriptor: string,
    permissionSetId: string,
    permissionSetToken: string,
    accountName: string
): Promise<SubjectPermissions | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService
        .getDataAsync<SubjectPermissions>(
            PermissionsMetadataProviderId,
            {
                subjectDescriptor: subjectDescriptor,
                permissionSetId: permissionSetId,
                permissionSetToken: permissionSetToken,
                accountName: accountName
            },
            true
        )
        .then(result => {
            return result;
        });
}

export function getResourcesTracePermissions(
    pageContext: IVssPageContext,
    subjectDescriptor: string,
    permissionSetId: string,
    permissionSetToken: string,
    namespaceId: string,
    token: string,
    permissionBit: string
): Promise<PermissionTrace | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService
        .getDataAsync<PermissionTrace>(PermissionsTraceMetadataProviderId, {
            subjectDescriptor: subjectDescriptor,
            permissionSetId: permissionSetId,
            permissionSetToken: permissionSetToken,
            namespaceId: namespaceId,
            token: token,
            permissionBit: permissionBit
        })
        .then(result => {
            return result;
        });
}
